import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ADSENSE_CLIENT, SLOT_INTERSTITIAL, adsLive, ensureAdsenseScript, pushAd, nextHouseAd } from "@/lib/ads";

const COUNTDOWN = 5; // seconds before the ad can be dismissed

// Full-screen interstitial gate. Shown ONCE before a minigame loads (mount-triggered),
// never between attempts. Highest revenue-per-view web placement.
export default function AdInterstitial({ onDone, label = "Your game is loading…" }) {
  const [left, setLeft] = useState(COUNTDOWN);
  const [house] = useState(() => nextHouseAd());
  const live = adsLive && !!SLOT_INTERSTITIAL; // need both client + ad-unit slot to serve

  useEffect(() => {
    if (live) { ensureAdsenseScript(); pushAd(); }
    const t = setInterval(() => setLeft((s) => (s <= 1 ? 0 : s - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  const ready = left <= 0;

  return createPortal(
    <div data-testid="ad-interstitial" className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 pop-in">
      <div className="w-full max-w-md panel-glow p-5 relative">
        <div className="flex items-center justify-between mb-3">
          <span className="label-cap text-[9px]">Advertisement</span>
          {ready ? (
            <button data-testid="ad-interstitial-continue" onClick={onDone} className="btn-primary text-xs px-4 py-1.5">Continue →</button>
          ) : (
            <span data-testid="ad-interstitial-countdown" className="text-xs text-muted-foreground mono">Continue in {left}s</span>
          )}
        </div>

        {live ? (
          <ins
            className="adsbygoogle"
            style={{ display: "block", width: "100%", minHeight: 250 }}
            data-ad-client={ADSENSE_CLIENT}
            data-ad-slot={SLOT_INTERSTITIAL}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        ) : (
          <div className="rounded-[var(--radius)] border border-primary/30 bg-primary/5 p-6 text-center" style={{ minHeight: 250 }}>
            <div className="w-14 h-14 mx-auto rounded-[var(--radius)] bg-primary/15 border border-primary/30 grid place-items-center mb-4">
              <span className="font-head font-black text-primary text-2xl">O</span>
            </div>
            <div className="font-head font-bold text-lg">{house.title}</div>
            <p className="text-sm text-muted-foreground mt-1 mb-4">{house.body}</p>
            <div className="inline-block btn-secondary text-xs px-4 py-2 opacity-90">{house.cta}</div>
            <p className="text-[10px] text-muted-foreground/60 mt-5">Sample house ad — real sponsored ads appear here once AdSense is live.</p>
          </div>
        )}

        <p className="text-center text-[11px] text-muted-foreground mt-3">{label}</p>
      </div>
    </div>,
    document.body
  );
}
